// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 477) return "static/chunks/8479bc39-5e3031113d56cc63.js";
	if (chunkId === 304) return "static/chunks/304-062b8df19d329535.js";
	if (chunkId === 540) return "static/chunks/540-a4b32304bbbbe2e0.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"3acb405fc8e33f20","270":"bd466443811bcb2f","320":"b9a5a0d50a63e090","340":"75388f4ad1808ea8","367":"645842bdb5f7ed52","713":"2042b0d7decff324","748":"e858cab8c75d92b2"}[chunkId] + ".js";
};